import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Button, Grid, Image, List as DSList, Typography } from '@iho-design-system/Loader';

/*
    - icon
*/
import heartSolidRedSVG from '../../assets/images/icons/heart-solid-red.svg';
import EmptySVG from '../../assets/images/icons/empty.svg';
import LoadingCustomSVG from '../../assets/images/icons/loading-custom.svg';

/*
    - api
*/
import removeFavoriteAPI from '../../api/remove/ChangeFavorite';

const List = ({ props, alertProps, reloadFavoriteProps }) => {

    /*
        - defaultData
    */
    const [favoritesData, setFavoritesData] = React.useState('loading');
    const [hotelNameSearchKey, setHotelNameSearchKey] = React.useState('');

    React.useEffect(() => {
        if (props.favorites !== '') {
            if (props.favorites.status === 200 && props.favorites.data.length > 0) {
                setFavoritesData(props.favorites.data);
            } else {
                setFavoritesData('empty');
            }
        }
        if (props.searchKey !== '') {
            setHotelNameSearchKey(props.hotelNameSearchKey);
        } else {
            setHotelNameSearchKey('')
        }
    }, [props]);

    /*
        - removeFavorite
    */
    const removeFavorite = async (hotelId) => {
        let parameters = {};
        parameters.HotelId = hotelId;
        let result = await removeFavoriteAPI(parameters);
        if (result === 'success') {
            alertProps(['success', 'با موفقیت انجام شد']);
            reloadFavoriteProps(Math.floor(Math.random() * 100));
        } else {
            alertProps(['danger', 'خطایی رخ داده است']);
        }
    }

    /*
        - link
    */
    const link = (path) => {
        window.open(`https://iranhotelonline.com${path}#roomReservation`, '_blank');
    }

    /*
        - scale
    */
    const screenWidth = window.innerWidth;
    let scale = '';
    if (screenWidth > 1400) {
        scale = 'xx-large';
    } else if (screenWidth <= 1400 && screenWidth > 1200) {
        scale = 'x-large';
    } else if (screenWidth <= 1200 && screenWidth > 992) {
        scale = 'large'
    } else if (screenWidth <= 992 && screenWidth > 768) {
        scale = 'medium'
    } else if (screenWidth <= 768 && screenWidth > 576) {
        scale = 'small'
    } else if (screenWidth <= 576) {
        scale = 'x-small'
    }

    if (favoritesData === 'loading') {
        return (
            <Image
                className={`d-block mx-auto`}
                src={LoadingCustomSVG}
                ms={{
                    width: '40px',
                    height: '40px'
                }} />
        );
    }

    if (favoritesData === 'empty') {
        return (
            <React.Fragment>
                <Box>
                    <Image
                        className={`mx-auto`}
                        src={EmptySVG}
                        ms={{
                            display: 'block',
                            width: '120px',
                            height: '120px'
                        }} />
                    <Typography
                        className={`d-block text-center`}
                        component='h2'>
                        لیست علاقه‌ مندی‌‌ های شما خالی است :(
                    </Typography>
                    <Box
                        className={`my-md`} />
                    <Typography
                        className={`d-block text-center`}
                        component='strong'>
                        تاکنون هیچ هتلی را ثبت نکرده اید!
                    </Typography>
                </Box>
            </React.Fragment>
        );
    }

    if (favoritesData !== 'empty') {
        return (
            <React.Fragment>
                <Grid>
                    <Grid.Wrapper>
                        {favoritesData.map((obj, index) => {
                            if (hotelNameSearchKey.length === 0 || obj.Name.includes(hotelNameSearchKey)) {
                                return (
                                    <React.Fragment
                                        key={index}>
                                        {(scale === 'xx-large' || scale === 'x-large' || scale === 'large') &&
                                            <Grid.Item
                                                size='col-6'>
                                                <DSList
                                                    className={`d-flex bg-white border-solid border-light rounded-lg shadow-dark-hover overflow-hidden`}>
                                                    <DSList.Item>
                                                        <Box
                                                            ms={{
                                                                width: '275px',
                                                                height: 'auto'
                                                            }}>
                                                            <Image
                                                                src={`${obj.PictureUrl}`}
                                                                ms={{
                                                                    height: 'auto !important',
                                                                    objectFit: 'cover'
                                                                }} />
                                                        </Box>
                                                    </DSList.Item>
                                                    <DSList.Item
                                                        className={`w-100 p-xl position-relative`}>
                                                        <Box
                                                            onClick={() => removeFavorite(obj.HotelId)}
                                                            className={`pointer position-absolute left-xl`}>
                                                            <Image
                                                                src={heartSolidRedSVG}
                                                                ms={{
                                                                    width: '24px',
                                                                    height: '24px'
                                                                }} />
                                                        </Box>
                                                        <Typography
                                                            className={`d-block`}
                                                            component='h5'>
                                                            {obj.Name}
                                                        </Typography>
                                                        <Typography
                                                            className={`my-sm mb-0`}>
                                                            {obj.Address}
                                                        </Typography>
                                                        <Box
                                                            className={`d-flex align-center justify-content-between w-100 px-xl position-absolute bottom-xl right-0`}>
                                                            <Box>
                                                                <Typography
                                                                    component='small'>
                                                                    شروع قیمت از
                                                                </Typography>
                                                                <Box
                                                                    className='mx-sm mr-0 divider-horizontal' />
                                                                <Typography
                                                                    component='strong'>
                                                                    {(Math.floor(obj.Price) / 10).toLocaleString()} تومان
                                                                </Typography>
                                                            </Box>
                                                            <Button
                                                                onClick={() => link(obj.HotelUrl)}
                                                                variant='filled'
                                                                color='primary'
                                                                size='sm'>
                                                                رزرو کنید
                                                            </Button>
                                                        </Box>
                                                    </DSList.Item>
                                                </DSList>
                                            </Grid.Item>
                                        }
                                        {(scale === 'medium' || scale === 'small') &&
                                            <Grid.Item
                                                size='col-6'>
                                                <DSList
                                                    className={`bg-white border-solid border-light rounded-lg shadow-dark-hover overflow-hidden`}>
                                                    <DSList.Item>
                                                        <Box
                                                            ms={{
                                                                width: '100%',
                                                                height: 'auto'
                                                            }}>
                                                            <Image
                                                                src={`${obj.PictureUrl}`}
                                                                ms={{
                                                                    height: 'auto !important',
                                                                    objectFit: 'cover'
                                                                }} />
                                                        </Box>
                                                    </DSList.Item>
                                                    <DSList.Item
                                                        className={`p-xl position-relative`}>
                                                        <Box
                                                            onClick={() => removeFavorite(obj.HotelId)}
                                                            className={`pointer position-absolute left-xl`}>
                                                            <Image
                                                                src={heartSolidRedSVG}
                                                                ms={{
                                                                    width: '24px',
                                                                    height: '24px'
                                                                }} />
                                                        </Box>
                                                        <Typography
                                                            className={`d-block`}
                                                            component='h5'>
                                                            {obj.Name}
                                                        </Typography>
                                                        <Typography>
                                                            {obj.Address}
                                                        </Typography>
                                                        <Box
                                                            className={`my-sm mb-0`} />
                                                        <Box
                                                            className={`d-flex align-center justify-content-between w-100`}>
                                                            <Box>
                                                                <Typography
                                                                    component='small'>
                                                                    شروع قیمت از
                                                                </Typography>
                                                                <Box
                                                                    className={`mx-sm mr-0`} />
                                                                <Typography
                                                                    component='strong'>
                                                                    {(Math.floor(obj.Price) / 10).toLocaleString()} تومان
                                                                </Typography>
                                                            </Box>
                                                            <Button
                                                                variant='filled'
                                                                color='primary'
                                                                size='sm'>
                                                                رزرو کنید
                                                            </Button>
                                                        </Box>
                                                    </DSList.Item>
                                                </DSList>
                                            </Grid.Item>
                                        }
                                        {(scale === 'x-small') &&
                                            <Grid.Item
                                                size='col-12'>
                                                <DSList
                                                    className={`bg-white border-solid border-light rounded-lg shadow-dark-hover overflow-hidden`}>
                                                    <DSList.Item>
                                                        <Image
                                                            src={`${obj.PictureUrl}`} />
                                                    </DSList.Item>
                                                    <DSList.Item
                                                        className={`p-xl position-relative`}>
                                                        <Box
                                                            onClick={() => removeFavorite(obj.HotelId)}
                                                            className={`pointer position-absolute left-xl`}>
                                                            <Image
                                                                src={heartSolidRedSVG}
                                                                ms={{
                                                                    width: '24px',
                                                                    height: '24px'
                                                                }} />
                                                        </Box>
                                                        <Typography
                                                            className={`d-block`}
                                                            component='h5'>
                                                            {obj.Name}
                                                        </Typography>
                                                        <Typography>
                                                            {obj.Address}
                                                        </Typography>
                                                        <Box
                                                            className={`my-sm mb-0`} />
                                                        <Box
                                                            className={`d-flex align-center justify-content-between w-100`}>
                                                            <Box>
                                                                <Typography
                                                                    component='small'>
                                                                    شروع قیمت از
                                                                </Typography>
                                                                <Box
                                                                    className={`mx-sm mr-0`} />
                                                                <Typography
                                                                    component='strong'>
                                                                    {(Math.floor(obj.Price) / 10).toLocaleString()} تومان
                                                                </Typography>
                                                            </Box>
                                                            <Button
                                                                variant='filled'
                                                                color='primary'
                                                                size='sm'>
                                                                رزرو کنید
                                                            </Button>
                                                        </Box>
                                                    </DSList.Item>
                                                </DSList>
                                            </Grid.Item>
                                        }
                                    </React.Fragment>
                                );
                            }
                            return null;
                        })}
                    </Grid.Wrapper>
                </Grid>
            </React.Fragment>
        );
    }

}

export default List;